'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dRestricted$002dDomains$0024 from "./presto.-List-Restricted-Domains$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481 from "./presto.-Presto-Router$$anon$81.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$80() {
  this.bmQ = null;
  this.bmI = null;
  this.bmJ = false;
  this.bmR = null;
  this.bmS = false;
  this.bmV = null;
  this.bmO = null;
  this.bmP = false;
  this.bmK = null;
  this.bmL = false;
  this.bmM = null;
  this.bmN = false;
  this.bmT = false;
  this.bmU = false;
  this.bmQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmV = "ListRestrictedDomains";
}
export { $c_Lpresto_PrestoRouter$$anon$80 as $c_Lpresto_PrestoRouter$$anon$80 };
$p = $c_Lpresto_PrestoRouter$$anon$80.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$80;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$80() {
}
export { $h_Lpresto_PrestoRouter$$anon$80 as $h_Lpresto_PrestoRouter$$anon$80 };
$h_Lpresto_PrestoRouter$$anon$80.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bmQ;
});
$p.M = (function() {
  if ((!this.bmJ)) {
    this.bmI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmJ = true;
  }
  return this.bmI;
});
$p.O = (function() {
  if ((!this.bmS)) {
    this.bmR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmS = true;
  }
  return this.bmR;
});
$p.E = (function() {
  return this.bmV;
});
$p.t = (function() {
  if ((!this.bmP)) {
    this.bmO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmP = true;
  }
  return this.bmO;
});
$p.N = (function() {
  if ((!this.bmL)) {
    this.bmK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmL = true;
  }
  return this.bmK;
});
$p.Q = (function() {
  if ((!this.bmN)) {
    this.bmM = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481.$c_Lpresto_PrestoRouter$$anon$81();
    this.bmN = true;
  }
  return this.bmM;
});
$p.v = (function() {
  if ((!this.bmU)) {
    this.bmT = false;
    this.bmU = true;
  }
  return this.bmT;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee535) => ((p) => \u03b4scrutinee535))($j_presto$002e$002dList$002dRestricted$002dDomains$0024.$m_Lpresto_ListRestrictedDomains$())));
});
var $d_Lpresto_PrestoRouter$$anon$80 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$80, "presto.PrestoRouter$$anon$80", ({
  OY: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$80 as $d_Lpresto_PrestoRouter$$anon$80 };
//# sourceMappingURL=presto.-Presto-Router$$anon$80.js.map
